import { ClaimType, DaysType } from 'components/ClaimCard/types';
import { STATUS_OBJ, DAYS_OBJ } from './statusEnum';

export const claimTypeOptions: ClaimType = {
  [STATUS_OBJ.Analysis]: {
    value: 'Em Análise',
    tagType: 'alert',
  },
  [STATUS_OBJ.Pendent]: {
    value: 'Pendente',
    tagType: 'error',
  },
  [STATUS_OBJ.Compensated]: {
    value: 'Indenizado',
    tagType: 'success',
  },
  [STATUS_OBJ.Closed]: {
    value: 'Encerrado',
    tagType: 'disabled',
  },
  [STATUS_OBJ.Credit]: {
    value: 'Crédito',
    tagType: 'alert',
  },
  [STATUS_OBJ.CompensatedPP]: {
    value: 'Pago Parcial',
    tagType: 'success',
  },
  default: {
    value: 'Default',
    tagType: 'disabled',
  },
};

export const claimDaysInactive: DaysType = {
  [DAYS_OBJ.thirtyDaysOrMore]: {
    days: '30 dias',
    color: '#1FA685',
  },
  [DAYS_OBJ.sixtyDaysOrMore]: {
    days: '60 dias',
    color: '#FF01B1',
  },
  [DAYS_OBJ.ninetyDaysOrMore]: {
    days: '90 dias',
    color: '#FF5501',
  },
  [DAYS_OBJ.hundredTwentyDaysOrMore]: {
    days: '120 dias',
    color: '#DE1616',
  },
  default: {
    days: 'Default',
    color: 'disabled',
  },
};
